<template>
    <sys-register-base
        :loading="loading"
        @onSave="save"
        :model.sync="model"
        :title="title"
        icon="mdi-clock-check-outline"
        v-bind:show.sync="dialog"
        maxWidth="50%"
    >
        <template v-slot:form>
            <v-container>
                <v-row>
                    <v-col cols="12" sm="12">
                        <sys-select-teacher-work-regime
                            :model.sync="model.teacher_work_regime_id"
                            :error="!!errors.teacher_work_regime_id"
                            :errors="errors.teacher_work_regime_id"
                            label="Regime de Trabalho*"
                            dense
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            type="number"
                            :error="!!errors.work_load_min"
                            :error-messages="errors.work_load_min"
                            v-model="model.work_load_min"
                            label="CH Mínima Total (Sala de Aula + Atividades)*"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            type="number"
                            step="0.01"
                            suffix="%"
                            :error="!!errors.percent_activities"
                            :error-messages="errors.percent_activities"
                            v-model="model.percent_activities"
                            label="Percentual mínimo de CH de Atividades*"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterTeacherWorkRegimeRule",
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
    }),

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {

        dialog(dialog_new, dialog_old) {
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }
        },

        show(show_new, show_old) {
            this.dialog = show_new;

            if(show_new){
                this.error = false;
                this.errors = {};
            }
        },

    },
    props: {
        model: {
            default: null
        },
        title: {
            type: String,
            default: "Regra de Regime de Trabalho"
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('teacherWorkRegimeRule', ['ActionUpdateTeacherWorkRegimeRule', 'ActionCreateTeacherWorkRegimeRule']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            Object.assign(this.model, {institution_id: this.acesso.instituicao.id})

            if(edit) {
                this.ActionUpdateTeacherWorkRegimeRule(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateTeacherWorkRegimeRule(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>
